import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vvesnhgfderohmzrrrhp.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ2ZXNuaGdmZGVyb2htenJycmhwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2Mjg1OTgsImV4cCI6MjA3MTIwNDU5OH0.kj0mIlqAsyVwNKTC4KTIuEpVaqMxRK87Qni6PuSBB54';

const supabase = createClient(supabaseUrl, supabaseAnonKey);
export default supabase;
